import { styled, Typography } from '@mui/material'

export const SplashScreen = styled('div')(({ theme }) => ({
  width: '100vw',
  height: '100vh',
  backgroundColor: theme.palette.secondary.main,
  display: 'grid',
  justifyItems: 'center',
  alignItems: 'center'
}))

export const SplashContainer = styled('div')({
  backgroundColor: 'white',
  width: 'auto',
  height: 'auto',
  borderRadius: '10px',
  textAlign: 'right',
  display: 'grid',
  padding: '8% 15% 8% 15%',
  alignItems: 'center',
  gridTemplateColumns: 'auto auto',
  margin: '10px',
  '@media only screen and (max-width: 450px)': {
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr 1fr',
    justifyTtems: 'center',
    textAlign: 'center'
  }
})

export const StyledText = styled(Typography)({
  fontSize: '18px',
  marginLeft: '8px',
  '@media only screen and (max-width: 450px)': {
    marginRight: 0
  }
})
